import { useAuth } from "@/context/Auth/CombinedAuthContext";
import logo_no from "@/media/nation.png";
import { contributorLogin } from "@/services/external-contributors-functions";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { toast } from "sonner";
import z from "zod";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader } from "../ui/card";
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "../ui/form";
import { Input } from "../ui/input";

const formSchema = z.object({
	email: z.string().email("Invalid email address"),
	password: z.string().min(6, "Password must be at least 6 characters"),
});

const ContributorLogin = () => {
	const { loginWithEmail } = useAuth();
	const form = useForm({
		resolver: zodResolver(formSchema),
		defaultValues: {
			email: "",
			password: "",
		},
	});

	const login = useMutation({
		mutationKey: "contributor_login",
		mutationFn: (data: z.infer<typeof formSchema>) =>
			contributorLogin(data.email, data.password),
		onSuccess: (response) => {
			toast.success("Login successful!");
			sessionStorage.setItem("cad", JSON.stringify(response));
			loginWithEmail(response);
		},
		onError: () => {
			toast.error("Login failed. Please check your credentials.");
		},
	});

	const onSubmit = (data: z.infer<typeof formSchema>) => {
		login.mutate(data);
	};

	return (
		<Card className="bg-white text-center p-6 border rounded-md w-full mx-4 sm:max-w-lg">
			<CardHeader className="flex flex-col items-center justify-center gap-2">
				<div className="aspect-square w-16">
					<img src={logo_no} alt="" className="w-full h-full" />
				</div>
				<h1 className="text-4xl font-bold">Claims Contributor Login</h1>
			</CardHeader>
			<Form {...form}>
				<form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
					<CardContent className="text-left space-y-4">
						<FormField
							name="email"
							render={({ field }) => (
								<FormItem>
									<FormLabel>Email</FormLabel>
									<FormControl>
										<Input {...field} type="email" />
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>
						<FormField
							name="password"
							render={({ field }) => (
								<FormItem>
									<FormLabel>Password</FormLabel>
									<FormControl>
										<Input {...field} type="password" />
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>
						<Button type="submit" className="w-full" disabled={login.isLoading}>
							{login.isLoading ? "Logging in" : "Log In"}
						</Button>
					</CardContent>
				</form>
			</Form>
		</Card>
	);
};

export default ContributorLogin;
